import { RouteObject } from 'react-router-dom';

const AdminHomepageRoutes: RouteObject[] = [
  {
    path: '*',
    id: 'admin-homepage-root',
    shouldRevalidate: () => false,
    async lazy() {
      const Homepage = await import('./homepage.view');
      return { Component: Homepage.default };
    },
  },
];

export default AdminHomepageRoutes;
